import { makeServerProps } from '@/server/query'

import makePage from '@/client/services/pages/makePage'

import { useUserFromQuery, useUserUpcomingSeries } from '@/components/Profile/helpers'
import ProfileLayout from '@/components/Profile/ProfileLayout'
import ProfileOverviewTab from '@/components/Profile/ProfileOverviewTab'

function ProfileIndex(): JSX.Element {
  const { user, userIdQuery } = useUserFromQuery()
  const upcomingSeries = useUserUpcomingSeries()

  return (
    <ProfileLayout currentTab="Overview">
      <ProfileOverviewTab user={user} userIdQuery={userIdQuery} upcomingSeries={upcomingSeries} />
    </ProfileLayout>
  )
}

const ProfileIndexPage = makePage(ProfileIndex, {
  onboardingUsers: 'allowed',
})
export const getServerSideProps = makeServerProps(ProfileIndexPage)
export default ProfileIndexPage
